import { FlowTypes, SignUpSteps } from 'utils/enums';

export const BENEFITS_CHECK_WM_FLOW_PART: SignUpSteps[] = [
  SignUpSteps.WMNewTargetWeight,
  SignUpSteps.WMSexAtBirth,
  SignUpSteps.WMDiabetesTypeOneQuestion,
  SignUpSteps.WMPancreatitisQuestion,
  SignUpSteps.WMThyroidNodulesQuestion,
  SignUpSteps.WMGallbladderQuestion,
  SignUpSteps.WMGallStonesQuestion,
  SignUpSteps.WMMedicalConditions,
  SignUpSteps.WMSetPassword,
  SignUpSteps.MarketingLowerPrice,
  SignUpSteps.MarketingWorkingOnApproval,
  SignUpSteps.MarketingCompare,
  SignUpSteps.PlanSelect,
  SignUpSteps.MarketingRegularMeetings,
  SignUpSteps.WMScheduleAppointment,
  SignUpSteps.RTBCheckout,
  SignUpSteps.WMCompleteOnboarding
];

export const BENEFITS_CHECK_TT_FLOW_PART: SignUpSteps[] = [
  SignUpSteps.WMWhatNext,
  SignUpSteps.WMSexAtBirth,
  SignUpSteps.WMDiabetesTypeOneQuestion,
  SignUpSteps.WMKidneyStones,
  SignUpSteps.WMPriorSeizures,
  SignUpSteps.WMGlaucoma,
  SignUpSteps.WMMAOInhibitors,
  SignUpSteps.WMLiverOrKidneyImpairment,
  SignUpSteps.WMLacticAcidosis,
  SignUpSteps.WMBupropion,
  SignUpSteps.WMSideEffectsWithMetforminBupropion,
  SignUpSteps.WMKetogenicDiet,
  SignUpSteps.BipolarDisorder,
  SignUpSteps.WMTTResults,
  SignUpSteps.WMSetPassword,
  SignUpSteps.PlanSelect,
  SignUpSteps.RTBCheckout,
  SignUpSteps.WMCompleteOnboarding
];

export const MIF_STEPS: SignUpSteps[] = [
  SignUpSteps.Medications,
  SignUpSteps.Allergies,
  SignUpSteps.HealthConditions,
  SignUpSteps.ChronicDiseases,
  SignUpSteps.AdditionalConditions,
  SignUpSteps.WomensHealth,
  SignUpSteps.SocialHistory,
  SignUpSteps.MifSummary
];

const WEIGHT_MANAGEMENT_FLOW_STEPS: SignUpSteps[] = [
  SignUpSteps.State,
  SignUpSteps.WMWeightLoseAim,
  SignUpSteps.WMAge,
  SignUpSteps.WMUserHealthState,
  SignUpSteps.WMDiabetesQuestion,
  SignUpSteps.WMYouAreInGoodHands,
  SignUpSteps.WMHeightAndWeight,
  SignUpSteps.WMNewTargetWeight,
  SignUpSteps.InsuranceType,
  SignUpSteps.WMCongrats,
  SignUpSteps.WMBasicInfo,
  SignUpSteps.WMAddress,
  SignUpSteps.WMDOB,
  SignUpSteps.WMSexAtBirth,
  SignUpSteps.WMPancreatitisQuestion,
  SignUpSteps.WMThyroidNodulesQuestion,
  SignUpSteps.WMGallbladderQuestion,
  SignUpSteps.WMGallStonesQuestion,
  SignUpSteps.WMMedicalConditions,
  SignUpSteps.WMPhoneNumber,
  SignUpSteps.WMSetPassword,
  SignUpSteps.PreferredMedication,
  SignUpSteps.MarketingLowerPrice,
  SignUpSteps.MarketingWorkingOnApproval,
  SignUpSteps.MarketingCompare,
  SignUpSteps.MarketingRatedNumberOne,
  SignUpSteps.PlanSelect,
  // SignUpSteps.MarketingMoneyBackGuarantee,
  SignUpSteps.NoticeForCalifornia,
  SignUpSteps.MarketingRegularMeetings,
  SignUpSteps.WMScheduleAppointment,
  SignUpSteps.AppointmentConfirmation,
  SignUpSteps.WMCheckout,
  SignUpSteps.WMCompleteOnboarding
];

const WEIGHT_MANAGEMENT_OPTAVIA_FLOW_STEPS: SignUpSteps[] = [
  SignUpSteps.State,
  SignUpSteps.WMWeightLoseWithoutUncertainty,
  SignUpSteps.WMWeightLoseAim,
  SignUpSteps.WMAge,
  SignUpSteps.WMUserHealthState,
  SignUpSteps.WMDiabetesQuestion,
  SignUpSteps.WMYouAreInGoodHands,
  SignUpSteps.WMHeightAndWeight,
  SignUpSteps.WMNewTargetWeight,
  SignUpSteps.InsuranceType,
  SignUpSteps.WMCongrats,
  SignUpSteps.WMBasicInfo,
  SignUpSteps.Agreement,
  SignUpSteps.WMAddress,
  SignUpSteps.WMDOB,
  SignUpSteps.WMSexAtBirth,
  SignUpSteps.WMPancreatitisQuestion,
  SignUpSteps.WMThyroidNodulesQuestion,
  SignUpSteps.WMGallbladderQuestion,
  SignUpSteps.WMGallStonesQuestion,
  SignUpSteps.WMMedicalConditions,
  SignUpSteps.WMPhoneNumber,
  SignUpSteps.WMSetPassword,
  SignUpSteps.PreferredMedication,
  SignUpSteps.MarketingCompare,
  SignUpSteps.MarketingRatedNumberOne,
  SignUpSteps.PlanSelect,
  SignUpSteps.NoticeForCalifornia,
  SignUpSteps.MarketingRegularMeetings,
  SignUpSteps.WMScheduleAppointment,
  SignUpSteps.AppointmentConfirmation,
  SignUpSteps.WMCheckout,
  SignUpSteps.WMCompleteOnboarding
];

const WEIGHT_MANAGEMENT_BLUE_LINE_FLOW_STEPS: SignUpSteps[] = [
  SignUpSteps.BlueLineIntro,
  SignUpSteps.State,
  SignUpSteps.WMWeightLoseAim,
  SignUpSteps.WMAge,
  SignUpSteps.WMUserHealthState,
  SignUpSteps.WMDiabetesQuestion,
  SignUpSteps.WMYouAreInGoodHands,
  SignUpSteps.WMHeightAndWeight,
  SignUpSteps.WMCongrats,
  SignUpSteps.WMBasicInfo,
  SignUpSteps.WMAddress,
  SignUpSteps.WMDOB,
  SignUpSteps.WMSexAtBirth,
  SignUpSteps.WMPancreatitisQuestion,
  SignUpSteps.WMThyroidNodulesQuestion,
  SignUpSteps.WMGallbladderQuestion,
  SignUpSteps.WMGallStonesQuestion,
  SignUpSteps.WMMedicalConditions,
  SignUpSteps.WMPhoneNumber,
  SignUpSteps.WMSetPassword,
  SignUpSteps.YourWeightLossProgram,
  // SignUpSteps.PreferredMedication,
  SignUpSteps.MarketingCompare,
  SignUpSteps.MarketingRatedNumberOne,
  SignUpSteps.PlanSelect,
  SignUpSteps.MarketingRegularMeetings,
  SignUpSteps.WMScheduleAppointment,
  SignUpSteps.WMCheckout,
  SignUpSteps.WMCompleteOnboarding
];

const WEIGHT_MANAGEMENT_ASYNC_FLOW_STEPS: SignUpSteps[] = [
  SignUpSteps.State,
  SignUpSteps.WMWeightLoseAim,
  SignUpSteps.WMKnowledgeAboutGLP1,
  SignUpSteps.WMAge,
  SignUpSteps.WMUserHealthState,
  SignUpSteps.WMDiabetesQuestion,
  SignUpSteps.WMYouAreInGoodHands,
  SignUpSteps.WMHeightAndWeight,
  SignUpSteps.WMNewTargetWeight,
  SignUpSteps.InsuranceType,
  SignUpSteps.WMBasicInfo,
  SignUpSteps.WMAddress,
  SignUpSteps.WMDOB,
  SignUpSteps.WMSexAtBirth,
  SignUpSteps.WMPancreatitisQuestion,
  SignUpSteps.WMThyroidNodulesQuestion,
  SignUpSteps.WMGallbladderQuestion,
  SignUpSteps.WMGallStonesQuestion,
  SignUpSteps.WMMedicalConditions,
  SignUpSteps.WMPhoneNumber,
  SignUpSteps.WMSetPassword,
  SignUpSteps.WMCongrats,
  SignUpSteps.PreferredMedication,
  SignUpSteps.MarketingLowerPrice,
  SignUpSteps.MarketingWorkingOnApproval,
  SignUpSteps.MarketingCompare,
  SignUpSteps.MarketingRatedNumberOne,
  SignUpSteps.ShouldUseInsurance,
  SignUpSteps.PlanSelect,
  SignUpSteps.NoticeForCalifornia,
  // SignUpSteps.MarketingMoneyBackGuarantee,
  SignUpSteps.MarketingRegularMeetings,
  SignUpSteps.WMScheduleAppointment,
  SignUpSteps.AppointmentConfirmation,
  SignUpSteps.WMCheckout,
  SignUpSteps.WMCompleteOnboarding
];

const WEIGHT_MANAGEMENT_BALLAD_HEALTH_FLOW_STEPS: SignUpSteps[] = [
  SignUpSteps.State,
  SignUpSteps.WMWeightLoseAim,
  // SignUpSteps.WMKnowledgeAboutGLP1,
  SignUpSteps.WMAge,
  SignUpSteps.WMUserHealthState,
  SignUpSteps.WMDiabetesQuestion,
  SignUpSteps.WMYouAreInGoodHands,
  SignUpSteps.WMHeightAndWeight,
  SignUpSteps.WMNewTargetWeight,
  // SignUpSteps.InsuranceType,
  SignUpSteps.WMBasicInfo,
  SignUpSteps.WMAddress,
  SignUpSteps.WMDOB,
  SignUpSteps.WMSexAtBirth,
  SignUpSteps.WMPancreatitisQuestion,
  SignUpSteps.WMThyroidNodulesQuestion,
  SignUpSteps.WMGallbladderQuestion,
  SignUpSteps.WMGallStonesQuestion,
  SignUpSteps.WMMedicalConditions,
  SignUpSteps.WMPhoneNumber,
  SignUpSteps.WMSetPassword,
  // SignUpSteps.WMCongrats,
  // SignUpSteps.PreferredMedication,
  // SignUpSteps.MarketingLowerPrice,
  // SignUpSteps.MarketingWorkingOnApproval,
  SignUpSteps.MarketingCompare,
  SignUpSteps.MarketingRatedNumberOne,
  // SignUpSteps.ShouldUseInsurance,
  SignUpSteps.PlanSelect,
  SignUpSteps.NoticeForCalifornia,
  // SignUpSteps.MarketingMoneyBackGuarantee,
  SignUpSteps.MarketingRegularMeetings,
  SignUpSteps.WMScheduleAppointment,
  SignUpSteps.AppointmentConfirmation,
  SignUpSteps.WMCheckout,
  SignUpSteps.WMCompleteOnboarding
];

const WEIGHT_MANAGEMENT_MEDICATIONS_FLOW_STEPS: SignUpSteps[] = [
  SignUpSteps.State,
  SignUpSteps.WMWeightLoseAim,
  SignUpSteps.WMKnowledgeAboutGLP1,
  SignUpSteps.WMAge,
  SignUpSteps.WMUserHealthState,
  SignUpSteps.WMDiabetesQuestion,
  SignUpSteps.WMYouAreInGoodHands,
  SignUpSteps.WMHeightAndWeight,
  SignUpSteps.WMNewTargetWeight,
  SignUpSteps.InsuranceType,
  SignUpSteps.WMBasicInfo,
  SignUpSteps.WMAddress,
  SignUpSteps.WMDOB,
  SignUpSteps.WMSexAtBirth,
  SignUpSteps.WMPancreatitisQuestion,
  SignUpSteps.WMThyroidNodulesQuestion,
  SignUpSteps.WMGallbladderQuestion,
  SignUpSteps.WMGallStonesQuestion,
  SignUpSteps.WMMedicalConditions,
  SignUpSteps.WMPhoneNumber,
  SignUpSteps.WMSetPassword,
  SignUpSteps.WMCongrats,
  SignUpSteps.PreferredMedication,
  SignUpSteps.MarketingLowerPrice,
  SignUpSteps.MarketingWorkingOnApproval,
  SignUpSteps.MarketingCompare,
  SignUpSteps.MarketingRatedNumberOne,
  SignUpSteps.ShouldUseInsurance,
  SignUpSteps.PlanSelect,
  SignUpSteps.NoticeForCalifornia,
  // SignUpSteps.MarketingMoneyBackGuarantee,
  SignUpSteps.MarketingRegularMeetings,
  SignUpSteps.WMScheduleAppointment,
  SignUpSteps.AppointmentConfirmation,
  SignUpSteps.WMCheckout,
  SignUpSteps.WMCompleteOnboarding
];

const WEIGHT_MANAGEMENT_INSURANCE_DISCOVERY_FLOW_STEPS = [
  SignUpSteps.MarketingVideo,
  SignUpSteps.WMUserHealthState,
  SignUpSteps.WMDiabetesQuestion,
  SignUpSteps.WMHeightAndWeight,
  SignUpSteps.WMNewTargetWeight,
  SignUpSteps.WMBasicInfo,
  SignUpSteps.WMDOB,
  SignUpSteps.InsuranceForAppointments,
  // SignUpSteps.InsuranceMedicationsToBeDiscussed,
  SignUpSteps.InsuranceForMedications,
  SignUpSteps.InsuranceLowCostOptions,
  SignUpSteps.WMCongrats,
  SignUpSteps.WMAddress,
  SignUpSteps.WMSexAtBirth,
  SignUpSteps.WMPancreatitisQuestion,
  SignUpSteps.WMThyroidNodulesQuestion,
  SignUpSteps.WMGallbladderQuestion,
  SignUpSteps.WMGallStonesQuestion,
  SignUpSteps.WMMedicalConditions,
  SignUpSteps.WMPhoneNumber,
  SignUpSteps.WMSetPassword,
  SignUpSteps.MarketingCompare,
  SignUpSteps.NoticeForCalifornia,
  SignUpSteps.PlanSelect,
  SignUpSteps.MarketingRegularMeetings,
  SignUpSteps.WMScheduleAppointment,
  SignUpSteps.WMCheckout,
  SignUpSteps.WMCompleteOnboarding
];

export const WEIGHT_MANAGEMENT_INSURANCE_BENEFITS_CHECK_NEW_FLOW_STEPS: SignUpSteps[] = [
  SignUpSteps.CheckMyBenefits,
  SignUpSteps.PersonalDetails,
  SignUpSteps.DobStep,
  SignUpSteps.AddInsurance,
  SignUpSteps.VerifyInsurance,
  SignUpSteps.CalculateBMI,
  SignUpSteps.UnlockYourResults,
  SignUpSteps.BenefitsResult,
  SignUpSteps.WMWeightLoseAim,
  SignUpSteps.WMUserHealthState,
  SignUpSteps.WMYouAreInGoodHands,
  SignUpSteps.WMHeightAndWeight
];

export const TRIPLE_THERAPY_FLOW_STEPS: SignUpSteps[] = [
  SignUpSteps.State,
  SignUpSteps.WMWeightLoseAim,
  SignUpSteps.WMAge,
  SignUpSteps.WMUserHealthState,
  SignUpSteps.WMWhyTT,
  SignUpSteps.WMDiabetesQuestion,
  SignUpSteps.WMYouAreInGoodHands,
  SignUpSteps.WMHeightAndWeight,
  SignUpSteps.WMCongrats,
  SignUpSteps.WMBasicInfo,
  SignUpSteps.WMAddress,
  SignUpSteps.WMDOB,
  SignUpSteps.WMSexAtBirth,
  SignUpSteps.WMWhatNext,
  // SignUpSteps.WMBloodPressure,
  SignUpSteps.WMKidneyStones,
  SignUpSteps.WMPriorSeizures,
  SignUpSteps.WMGlaucoma,
  SignUpSteps.WMMAOInhibitors,
  SignUpSteps.WMLiverOrKidneyImpairment,
  SignUpSteps.WMLacticAcidosis,
  SignUpSteps.WMBupropion,
  SignUpSteps.WMSideEffectsWithMetforminBupropion,
  SignUpSteps.WMKetogenicDiet,
  SignUpSteps.BipolarDisorder,
  SignUpSteps.WMTTResults,
  SignUpSteps.WMLabWork,
  SignUpSteps.WMPhoneNumber,
  SignUpSteps.WMSetPassword,
  SignUpSteps.PlanSelect,
  SignUpSteps.WMScheduleAppointment,
  SignUpSteps.AppointmentConfirmation,
  SignUpSteps.WMCheckout,
  SignUpSteps.WMCompleteOnboarding
];

export const FLOW_TYPES: { [key in FlowTypes]: SignUpSteps[] } = {
  [FlowTypes.BlueLineFlow]: WEIGHT_MANAGEMENT_BLUE_LINE_FLOW_STEPS,
  [FlowTypes.TripleTherapy]: TRIPLE_THERAPY_FLOW_STEPS,
  [FlowTypes.WeightManagementBalladHealth]: WEIGHT_MANAGEMENT_BALLAD_HEALTH_FLOW_STEPS,
  [FlowTypes.WeightManagementBenefitsCheckNew]:
    WEIGHT_MANAGEMENT_INSURANCE_BENEFITS_CHECK_NEW_FLOW_STEPS,
  [FlowTypes.WeightManagementFlow]: WEIGHT_MANAGEMENT_FLOW_STEPS,
  [FlowTypes.WeightManagementFlowAsync]: WEIGHT_MANAGEMENT_ASYNC_FLOW_STEPS,
  [FlowTypes.WeightManagementFlowInsuranceDiscovery]:
    WEIGHT_MANAGEMENT_INSURANCE_DISCOVERY_FLOW_STEPS,
  [FlowTypes.WeightManagementFlowInsuranceMedications]: WEIGHT_MANAGEMENT_MEDICATIONS_FLOW_STEPS,
  [FlowTypes.WeightManagementFlowMedicaid]: WEIGHT_MANAGEMENT_FLOW_STEPS,
  [FlowTypes.WeightManagementFlowOptavia]: WEIGHT_MANAGEMENT_OPTAVIA_FLOW_STEPS,
  [FlowTypes.WeightManagementSpecific]: WEIGHT_MANAGEMENT_FLOW_STEPS
};

export const WM_FLOWS = [
  FlowTypes.WeightManagementFlow,
  FlowTypes.WeightManagementFlowOptavia,
  FlowTypes.WeightManagementBalladHealth,
  FlowTypes.WeightManagementFlowInsuranceDiscovery,
  FlowTypes.WeightManagementFlowAsync,
  FlowTypes.WeightManagementFlowInsuranceMedications,
  FlowTypes.WeightManagementSpecific,
  FlowTypes.WeightManagementFlowMedicaid,
  FlowTypes.TripleTherapy,
  FlowTypes.WeightManagementBenefitsCheckNew,
  FlowTypes.BlueLineFlow
];

export const STATES_WHERE_ONBOARDING_IS_NOT_ALLOWED = [
  'American Samoa',
  // 'District of Columbia',
  'Guam',
  'Northern Mariana Islands',
  'U.S. Virgin Islands'
];
